<script>
export default {
  name: "dtsLogs",
  data() {
    return {
      trackList: [],
      loadingMain: false,
      loadingTop: false,
      loadingBottom: false,
      scrollListener: false,
      mergeFlash: false,
      forwardFlash: false
    };
  },
  methods: {
    async getData(id) {
      this.loadingMain = true;
      this.loadingTop = false;
      this.loadingBottom = false;
      await this.$bvModal.show("modal-trackLogs");
      this.trackList = [];
      await this.$store
        .dispatch("dtstrack/GetTrackTimeline", id)
        .then((res) => {
          res.data.trackSource = !res.data.sourceDepartment
            ? res.data.sourceDeliveryUnit
            : `${res.data.sourceDepartment} (${res.data.sourceDeliveryUnit})`;
          res.data.trackDestination = !res.data.destinationDepartment
            ? res.data.destinationDeliveryUnit
            : `${res.data.destinationDepartment} (${res.data.destinationDeliveryUnit})`;
          for (
            let logIndex = 0;
            logIndex < res.data.trackLogs.length;
            logIndex++
          ) {
            if (res.data.trackLogs[logIndex].logType == "POSTED") {
              if (
                res.data.trackLogs[logIndex - 1] != undefined &&
                (res.data.trackLogs[logIndex - 1].logType == "RETURNED" ||
                  res.data.trackLogs[logIndex - 1].logType == "UNSENT")
              ) {
                res.data.trackLogs[logIndex].trackDestination = null;
              } else {
                res.data.trackLogs[logIndex].trackDestination =
                  res.data.trackDestination;
              }
            }
          }
          res.data.branchParents = [];
          res.data.branchChildren = [];
          setTimeout(() => {
            this.trackList.push(res.data);
            this.getChild(res.data);
            this.getParent(res.data);
          }, 500);
        });
      await setTimeout(() => {
        this.loadingMain = false;
      }, 1000);
    },
    async getTop(branch, track) {
      this.loadingTop = true;
      setTimeout(() => {
        this.trackList.unshift(branch);
        this.getParent(branch);
        track.branchParents = [];
        this.loadingTop = false;
      }, 1000);
    },
    async getBottom(branch, track) {
      this.loadingBottom = true;
      setTimeout(() => {
        this.trackList.push(branch);
        this.getChild(branch);
        track.branchChildren = [];
        this.loadingBottom = false;
      }, 1000);
    },
    getParent(props) {
      if (props.trackParentIds.length > 0) {
        for (var count = 0; count < props.trackParentIds.length; count++) {
          this.$store
            .dispatch(
              "dtstrack/GetTrackTimeline",
              props.trackParentIds[count].trackId
            )
            .then((res) => {
              res.data.trackSource = !res.data.sourceDepartment
                ? res.data.sourceDeliveryUnit
                : `${res.data.sourceDepartment} (${res.data.sourceDeliveryUnit})`;
              res.data.trackDestination = !res.data.destinationDepartment
                ? res.data.destinationDeliveryUnit
                : `${res.data.destinationDepartment} (${res.data.destinationDeliveryUnit})`;
              for (
                let logIndex = 0;
                logIndex < res.data.trackLogs.length;
                logIndex++
              ) {
                if (res.data.trackLogs[logIndex].logType == "POSTED") {
                  if (
                    res.data.trackLogs[logIndex - 1] != undefined &&
                    (res.data.trackLogs[logIndex - 1].logType == "RETURNED" ||
                      res.data.trackLogs[logIndex - 1].logType == "UNSENT")
                  ) {
                    res.data.trackLogs[logIndex].trackDestination = null;
                  } else {
                    res.data.trackLogs[logIndex].trackDestination =
                      res.data.trackDestination;
                  }
                }
              }
              res.data.branchParents = [];
              res.data.branchChildren = [];
              setTimeout(() => {
                props.branchParents.unshift(res.data);
              }, 500);
            });
        }
        setTimeout(() => {
          if (count == props.trackParentIds.length) {
            if (props.branchParents.length == 1) {
              this.trackList.unshift(props.branchParents[0]);
              this.getParent(props.branchParents[0]);
              props.branchParents = [];
            }
          }
        }, 300);
      }
    },
    getChild(props) {
      if (props.trackChildIds.length > 0) {
        for (var count = 0; count < props.trackChildIds.length; count++) {
          this.$store
            .dispatch(
              "dtstrack/GetTrackTimeline",
              props.trackChildIds[count].trackId
            )
            .then((res) => {
              res.data.trackSource = !res.data.sourceDepartment
                ? res.data.sourceDeliveryUnit
                : `${res.data.sourceDepartment} (${res.data.sourceDeliveryUnit})`;
              res.data.trackDestination = !res.data.destinationDepartment
                ? res.data.destinationDeliveryUnit
                : `${res.data.destinationDepartment} (${res.data.destinationDeliveryUnit})`;
              for (
                let logIndex = 0;
                logIndex < res.data.trackLogs.length;
                logIndex++
              ) {
                if (res.data.trackLogs[logIndex].logType == "POSTED") {
                  if (
                    res.data.trackLogs[logIndex - 1] != undefined &&
                    (res.data.trackLogs[logIndex - 1].logType == "RETURNED" ||
                      res.data.trackLogs[logIndex - 1].logType == "UNSENT")
                  ) {
                    res.data.trackLogs[logIndex].trackDestination = null;
                  } else {
                    res.data.trackLogs[logIndex].trackDestination =
                      res.data.trackDestination;
                  }
                }
              }
              res.data.branchParents = [];
              res.data.branchChildren = [];
              setTimeout(() => {
                props.branchChildren.push(res.data);
              }, 500);
            });
        }
        setTimeout(() => {
          if (count == props.trackChildIds.length) {
            if (props.branchChildren.length == 1) {
              this.trackList.push(props.branchChildren[0]);
              this.getChild(props.branchChildren[0]);
              props.branchChildren = [];
            }
          }
        }, 300);
      }
    },
    viewDetails(props) {
      this.$emit("viewDetails", props);
    },
    scrollToTop() {
      const element = document.getElementById("track-0");
      element.scrollIntoView({ block: "start", behavior: "smooth" });
    },
    handleScroll(el) {
      if (el.srcElement.scrollTop > 10) {
        this.scrollListener = true;
      } else {
        this.scrollListener = false;
      }
    },
    flashMerge() {
      this.mergeFlash = true;
      setTimeout(() => {
        this.mergeFlash = false;
      }, 1000);
    },
    flashForward() {
      this.forwardFlash = true;
      setTimeout(() => {
        this.forwardFlash = false;
      }, 1000);
    }
  }
};
</script>

<template>
  <b-modal
    id="modal-trackLogs"
    title="Track Details"
    size="lg"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
  >
    <div v-if="loadingMain">
      <div class="h-50vh d-flex align-items-center justify-content-center">
        <div class="preloader-component me-2">
          <div class="status">
            <div class="spinner-chase w-25px h-25px">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <h5 class="mb-0">Loading...</h5>
      </div>
    </div>
    <div v-else class="py-3">
      <div @scroll="handleScroll" style="max-height: 600px; overflow: auto">
        <div v-for="(track, index) in trackList" :key="track.trackId">
          <div :id="`track-${index}`" class="row m-0 border-2 border-top">
            <div class="col-5 px-0">
              <div class="position-sticky py-3" style="top: 1px">
                <div>
                  <div class="font-size-15 text-white">
                    <b>{{ track.title }}</b>
                  </div>
                  <div class="font-size-14" v-if="track.trackingNumber">
                    <b>{{ track.trackingNumber }}</b>
                  </div>
                  <div
                    v-if="
                      track.trackLogs.length > 0 &&
                        track.trackLogs[track.trackLogs.length - 1].logType ==
                          'CREATED'
                    "
                  >
                    <div class="font-size-12">
                      Sent To:
                      <b>{{
                        track.trackDestination.length > 38
                          ? track.trackDestination.substring(0, 38) + "..."
                          : track.trackDestination
                      }}</b>
                    </div>
                    <div class="font-size-12">
                      Sent By:
                      <b>{{
                        track.trackSource.length > 38
                          ? track.trackSource.substring(0, 38) + "..."
                          : track.trackSource
                      }}</b>
                    </div>
                  </div>
                  <div v-else>
                    <div class="font-size-12">
                      Created By: <b>{{ track.trackSource }}</b>
                    </div>
                  </div>
                  <small
                    ><a
                      href="javascript: void(0);"
                      class="text-info"
                      @click="viewDetails(track.trackId)"
                    >
                      View Details
                    </a>
                  </small>
                </div>
              </div>
            </div>
            <div class="col-7 px-0">
              <div class="ms-1 py-3">
                <ul
                  class="verti-timeline list-unstyled ms-4"
                  v-for="(log, indexLog) in track.trackLogs"
                  :key="log.id"
                >
                  <li class="event-list">
                    <div class="event-timeline-dot">
                      <i
                        :class="
                          log.logType == 'CREATED'
                            ? 'bx bx-plus-circle text-muted font-size-18'
                            : log.logType == 'POSTED'
                            ? log.trackDestination != null
                              ? 'bx bx-send text-info font-size-18'
                              : 'bx bx-send text-danger font-size-18'
                            : log.logType == 'RETURNED'
                            ? 'bx bx-undo text-warning font-size-18'
                            : log.logType == 'UNSENT'
                            ? 'bx bx-undo text-warning font-size-18'
                            : log.logType == 'RECEIVED'
                            ? 'bx bx-folder-open text-pink font-size-18'
                            : log.logType == 'COMPLETED'
                            ? 'bx bx-check-circle text-success font-size-20'
                            : log.logType.includes('FORWARDED')
                            ? 'bx bx-send text-purple font-size-18'
                            : 'bx bx-send text-muted font-size-18'
                        "
                      ></i>
                    </div>
                    <div class="media">
                      <div class="media-body">
                        <div v-if="index == 0 && indexLog == 0">
                          <div v-if="loadingTop" class="pb-3">
                            <div
                              class="d-flex align-items-center justify-content-center py-4"
                            >
                              <div class="preloader-component me-2">
                                <div class="status">
                                  <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                  </div>
                                </div>
                              </div>
                              <h6 class="mb-0">Loading...</h6>
                            </div>
                          </div>
                          <div
                            v-else-if="track.branchParents.length > 0"
                            class="pb-3"
                          >
                            <div class="text-center" style="color: #7367f0">
                              <div>Multiple tracks forwarded.</div>
                              <b>Select track to continue.</b>
                            </div>
                            <div
                              v-for="branch in track.branchParents"
                              :key="branch.trackId"
                            >
                              <div
                                class="card my-2 mx-3 hoverable-link cursor-pointer"
                                @click="getTop(branch, track)"
                              >
                                <div class="p-2 border">
                                  <div>
                                    <b>{{ branch.title }}</b>
                                  </div>
                                  <div v-if="branch.trackingNumber">
                                    {{ branch.trackingNumber }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card">
                          <div class="p-2 border">
                            <b class="font-size-14">{{
                              log.logType == "CREATED"
                                ? `CREATED by ${track.trackSource}`
                                : log.logType == "POSTED"
                                ? log.trackDestination != null
                                  ? `SENT to ${log.trackDestination}`
                                  : `SENT but subsequently RETURNED`
                                : log.logType == "RETURNED"
                                ? `RETURNED to ${track.trackSource}`
                                : log.logType == "UNSENT"
                                ? `UNSENT by ${track.trackSource}`
                                : log.logType == "RECEIVED"
                                ? `RECEIVED by ${track.trackDestination}`
                                : log.logType == "COMPLETED"
                                ? `PROCESSED by ${track.trackDestination}`
                                : log.logType
                            }}</b>
                            <div class="font-size-12" v-if="log.comment">
                              Remarks: <b>{{ log.comment }}</b>
                            </div>
                          </div>
                          <div class="p-2 border">
                            <div>{{ log.logBy }}</div>
                            <small>
                              {{
                                formatDateWithTime(
                                  new Date(log.dateTimeCreated)
                                )
                              }}
                            </small>
                          </div>
                        </div>
                        <div
                          v-if="
                            index + 1 == trackList.length &&
                              indexLog + 1 == track.trackLogs.length
                          "
                        >
                          <div v-if="loadingBottom" class="mt-3">
                            <div
                              class="d-flex align-items-center justify-content-center py-4"
                            >
                              <div class="preloader-component me-2">
                                <div class="status">
                                  <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                  </div>
                                </div>
                              </div>
                              <h6 class="mb-0">Loading...</h6>
                            </div>
                          </div>
                          <div
                            v-else-if="track.branchChildren.length > 0"
                            class="mt-3"
                          >
                            <div class="text-center" style="color: #7367f0">
                              <div>Multiple tracks merged.</div>
                              <b>Select track to continue.</b>
                            </div>
                            <div
                              v-for="branch in track.branchChildren"
                              :key="branch.trackId"
                            >
                              <div
                                class="card my-2 mx-3 hoverable-link cursor-pointer"
                                @click="getBottom(branch, track)"
                              >
                                <div class="p-2 border">
                                  <div>
                                    <b>{{ branch.title }}</b>
                                  </div>
                                  <div v-if="branch.trackingNumber">
                                    {{ branch.trackingNumber }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <transition name="fade">
          <div
            v-if="scrollListener"
            class="position-absolute"
            style="bottom: 15px; right: 35px"
          >
            <div
              class="avatar-xs mx-auto cursor-pointer"
              @click="scrollToTop()"
            >
              <span class="avatar-title rounded-circle bg-gradient">
                <i class="bx bx-chevrons-up font-size-24"></i>
              </span>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </b-modal>
</template>

<style>
.fade-enter-active {
  animation: fade-in 0.5s;
}

.fade-leave-active {
  animation: fade-in 0.3s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
